export const ARENA_SERVER_COMPATIBILITY_ERROR = "Arena server update required";

/**
 * The 1.1.2 release introduced the 95-degree authoritative combat contract.
 * Only stable 1.1.x patches at or above that release are known compatible.
 * Unknown major/minor versions and prereleases fail closed; build metadata
 * does not affect compatibility. Admin balance/config versions are unrelated.
 */
export const isCompatibleArenaServerVersion = (version: unknown): boolean => {
  if (typeof version !== "string") return false;
  const match = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/.exec(version);
  if (!match || match[0] !== version) return false;
  const major = Number(match[1]);
  const minor = Number(match[2]);
  const patch = Number(match[3]);
  return major === 1 && minor === 1 && Number.isSafeInteger(patch) && patch >= 2;
};

export const assertArenaServerCompatibility = (meta: unknown): void => {
  const version = meta && typeof meta === "object" ? (meta as { clientVersion?: unknown }).clientVersion : undefined;
  if (!isCompatibleArenaServerVersion(version)) throw new Error(ARENA_SERVER_COMPATIBILITY_ERROR);
};
